import React from "react";
import Select from "react-select";
import Cookies from "js-cookie";
import ApiError from "../ApiError/ApiError";
import * as GlobalStyle from "../../CSSStyles";
import * as Styled from "./Style";
import closeIcon from "./../../assets/images/icons/ic_close.svg";
import infoIcon from "./../../assets/images/icons/ic_info_blue.svg";
import questionIcon from "./../../assets/images/icons/ic_question_blue.svg";

const AddressForm = (props) => {
  return (
    <Styled.AddressFormStyle className="address-form">
      {(props.data.showAddBilAddressForm) && (props.data.confirmAddressSummary && props.data.confirmAddressSummary.length == 1) ? '' : 
        <Styled.ModalCloseStyle
        type="button"
        onClick={props.close}
        title={"Close " + props.title.toLowerCase() + " form"}
      >
        <img
          src={`${closeIcon}`}
          alt=""
        />
      </Styled.ModalCloseStyle>
    }
      <p className="form-title">{props.title}</p>
      <p>All fields are required.</p>
      <Styled.AddressItemStyle>
        <Select
          className={
            (props.data.addAddressField.countryName ? "hasValue " : "") +
            " " +
            props.data.countryFocus +
            " selectInput addressRegion " +
            (props.data.countryChanged ? "countryChanged " : "") +
            (props.data.countryTyping ? "countryTyping " : "") +
            (props.data.addressErrors.addressRegion ? " error-field " : "")
          }
          onFocus={props.onCountryFocus}
          onBlur={props.onCountryBlur}
          onChange={props.onCountryChange}
          options={props.countryOptions}
          components={props.countryComponents}
          onInputChange={props.onCountryInputChange}
          value={
            props.process == "edit"
              ? {
                  label: props.data.addAddressField.countryName,
                  value: props.data.addAddressField.countryCode,
                }
              : props.process == "add"
              ? props.data.countryViewField
              : ""
          }
          closeMenuOnSelect={true}
          isClearable={true}
        />
        <label
          htmlFor="addressCountry"
          className=""
        >
          Country or Region
        </label>
        <span className="chosenSelect">{props.data.chosenCountry}</span>
        {props.data.addressErrors.addressRegion ? (
          <span className="error">{props.data.addressErrors.addressRegion}</span>
        ) : (
          ""
        )}
      </Styled.AddressItemStyle>
      <Styled.AddressItemStyle>
        <input
          type="text"
          name="firstName"
          title="First Name"
          aria-label="First Name"
          className={
            (props.data.addAddressField.firstName ? "hasValue " : "") +
            (props.data.addressErrors.addressFirstName ? " error-field" : "")
          }
          onChange={props.onFirstNameChange}
          value={props.data.addAddressField.firstName}
          ref={props.myRef}
          autoComplete="no"
        />
        <label htmlFor="addressFirstName">First name</label>
        {props.data.addressErrors.addressFirstName ? (
          <span className="error">{props.data.addressErrors.addressFirstName}</span>
        ) : (
          ""
        )}
      </Styled.AddressItemStyle>
      <Styled.AddressItemStyle>
        <input
          type="text"
          name="lastName"
          title="Last Name"
          aria-label="Last Name"
          className={
            props.data.addAddressField.lastName
              ? "hasValue "
              : "" + (props.data.addressErrors.addressLastName ? " error-field" : "")
          }
          onChange={props.onLastNameChange}
          value={props.data.addAddressField.lastName}
          autoComplete="no"
        />
        <label htmlFor="addressLastName">Last name</label>
        {props.data.addressErrors.addressLastName ? (
          <span className="error">{props.data.addressErrors.addressLastName}</span>
        ) : (
          ""
        )}
      </Styled.AddressItemStyle>
      <Styled.AddressItemStyle>
        <input
          type="text"
          name="streetAddressCompanyName"
          title="Street address, company name, c/o"
          aria-label="Street address, company name, c/o"
          className={
            props.data.addAddressField.addressLine1
              ? "hasValue "
              : "" + (props.data.addressErrors.addressLine1 ? " error-field" : "")
          }
          onChange={props.onLine1Change}
          value={props.data.addAddressField.addressLine1}
          autoComplete="no"
        />
        <label htmlFor="addressLine1">Street address, company name, c/o</label>
        {props.data.addressErrors.addressLine1 ? (
          <span className="error">{props.data.addressErrors.addressLine1}</span>
        ) : (
          ""
        )}
      </Styled.AddressItemStyle>
      {props.addressLine2 ? (
        <Styled.AddressItemStyle>
          <input
            type="text"
            name="apartmentSuiteFloor"
            title="Apartment, suite, floor, etc"
            aria-label="Apartment, suite, floor, etc"
            className={
              props.data.addAddressField.addressLine2
                ? "hasValue "
                : "" + (props.data.addressErrors.addressLine2 ? " error-field" : "")
            }
            onChange={props.onLine2Change}
            value={props.data.addAddressField.addressLine2}
            autoComplete="no"
          />
          <label htmlFor="addressLine2">Apartment, suite, floor, etc (Optional)</label>
          {props.data.addressErrors.addressLine2 ? (
            <span className="error">{props.data.addressErrors.addressLine2}</span>
          ) : (
            ""
          )}
        </Styled.AddressItemStyle>
      ) : props.data.addAddressLineShow ? (
        <Styled.AddressItemStyle>
          <input
            type="text"
            name="apartmentSuiteFloor"
            title="Apartment, suite, floor, etc"
            aria-label="Apartment, suite, floor, etc"
            className={
              props.data.addAddressField.addressLine2
                ? "hasValue "
                : "" + (props.data.addressErrors.addressLine2 ? " error-field" : "")
            }
            onChange={props.onLine2Change}
            value={props.data.addAddressField.addressLine2}
            autoComplete="no"
          />
          <label htmlFor="addressLine2">Apartment, suite, floor, etc (Optional)</label>
          {props.data.addressErrors.addressLine2 ? (
            <span className="error">{props.data.addressErrors.addressLine2}</span>
          ) : (
            ""
          )}
        </Styled.AddressItemStyle>
      ) : (
        <div>
          <Styled.AddAddressLineBtnStyle type="button" onClick={props.onNewAddressLineClick}>
            + Add apartment, suite, floor, etc.
          </Styled.AddAddressLineBtnStyle>
        </div>
      )}
      {}
      <Styled.AddressItemStyle>
        <input
          type="text"
          name="city"
          title="City"
          aria-label="City"
          className={
            props.data.addAddressField.city
              ? "hasValue "
              : "" + (props.data.addressErrors.addressCity ? " error-field" : "")
          }
          onChange={props.onCityChange}
          value={props.data.addAddressField.city}
          autoComplete="no"
        />
        <label
          htmlFor="addressCity"
        >
          {props.data.addAddressField.countryCode
            ? props.data.auRegionLocales.some((item) => props.data.addAddressField.countryCode === item.id || props.data.countryCodePick === item.isoCode2)
              ? "Suburb"
              : "City"
            : props.data.auRegionLocales.some((item) => props.data.countryCodePick === item.isoCode2)
            ? "Suburb"
            : "City"}
        </label>
        <span className="error">
          {props.data.addressErrors.addressCity
            ? props.data.addressErrors.addressCity == "Please enter your city"
              ? props.data.addAddressField.countryCode
                ? props.data.auRegionLocales.some((item) => props.data.addAddressField.countryCode === item.id || props.data.countryCodePick === item.isoCode2)
                  ? "Please enter your suburb"
                  : "Please enter your city"
                : props.data.auRegionLocales.some((item) => props.data.countryCodePick === item.isoCode2)
                ? "Please enter your suburb"
                : "Please enter your city"
              : props.data.addressErrors.addressCity
            : ""}
        </span>
      </Styled.AddressItemStyle>
      <Styled.AddressItemStyle>
        {props.stateZoneList.length > 0 ? (
          <div>
            <Select
              className={
                (props.data.addAddressField.stateZoneName ? "hasValue " : "") +
                " " +
                props.data.stateZoneFocus +
                " selectInput countyStateProvince "
              }
              onFocus={props.onStateZoneFocus}
              onBlur={props.onStateZoneBlur}
              onChange={props.onStateZoneChange}
              options={props.data.stateZone}
              value={props.data.stateViewField}
              isClearable={true}
              title="County, State or Province"
            />
            <label htmlFor="addressStateZone" className="">
              {props.data.provinceLabel || "County, State or Province"}
            </label>
            <span className="chosenSelect">{props.data.chosenStateZone}</span>
          </div>
        ) : (
          <Styled.AddressItemStyle>
            <input
              type="text"
              name="countyStateProvince"
              title="County, State or Province"
              aria-label="County, State or Province"
              className={
                props.data.addAddressField.stateName
                  ? "hasValue "
                  : "" + (props.data.addressErrors.addressState ? " error-field" : "")
              }
              onChange={props.onStateChange}
              value={props.data.addAddressField.stateName}
              autoComplete="no"
            />
            <label htmlFor="addressState">{props.data.provinceLabel || "County, State or Province"}</label>
            {props.data.addressErrors.addressState ? (
              <span className="error">{props.data.addressErrors.addressState}</span>
            ) : (
              ""
            )}
          </Styled.AddressItemStyle>
        )}
        {props.data.addressErrors.addressState
          ? ""
          :
            ""}
      </Styled.AddressItemStyle>
      <Styled.AddressItemStyle>
        <input
          type="text"
          name="zipPostalCode"
          title="ZIP or Postal code"
          aria-label="ZIP or Postal code"
          className={
            props.data.addAddressField.postCode
              ? "hasValue "
              : "" + (props.data.addressErrors.addressPostal ? " error-field" : "")
          }
          onChange={props.onPostalChange}
          value={props.data.addAddressField.postCode}
          autoComplete="no"
        />
        <label htmlFor="addressPostal">ZIP or Postal code</label>
        {props.data.addressErrors.addressPostal ? (
          <span className="error">{props.data.addressErrors.addressPostal}</span>
        ) : (
          ""
        )}
      </Styled.AddressItemStyle>
      <Styled.AddressItemStyle>
        <input
          type="text"
          name="phoneNumber"
          title="Phone Number"
          aria-label="Phone Number"
          className={
            props.data.addAddressField.phoneNumber
              ? "hasValue "
              : "" + (props.data.addressErrors.addressPhone ? " error-field" : "")
          }
          onChange={props.onPhoneChange}
          value={props.data.addAddressField.phoneNumber}
          autoComplete="no"
        />
        <label htmlFor="addressPhone">
          Phone number
        </label>
        <button className="tooltip">
          Tooltip message: Why do I need to provide my number? Cambridge University Press requires your phone number to
          ensure your purchase can be delivered successfully. It will be stored securely, and never shared with anyone,
          or used for any purpose, except with the delivery company responsible for delivering your purchase.
          <img src={`${questionIcon}`} alt="" />
        </button>
        <span className="tooltip-message">
          <strong>Why do I need to provide my number?</strong>
          <p>
            Cambridge University Press requires your phone number to ensure your purchase can be delivered successfully.
            It will be stored securely, and never shared with anyone, or used for any purpose, except with the delivery
            company responsible for delivering your purchase.
          </p>
          <span className="triangle-up"></span>
        </span>
        {props.data.addressErrors.addressPhone ? (
          <span className="error">{props.data.addressErrors.addressPhone}</span>
        ) : (
          ""
        )}
      </Styled.AddressItemStyle>
      {!props.data.confirmAddressSummary ?
        <p className="default-warning">
          <img
            src={`${infoIcon}`}
            alt=""
          /> This will be saved as your default address
        </p>
      : props.isPrimary ? 
        <p className="default-warning">
          <img
            src={`${infoIcon}`}
            alt=""
          /> This is your default address
        </p>
      : <div className="make-as-default">
          <input 
            type="checkbox" 
            name="makeAsDefault"
            title="Make as default address"
            aria-label="Make as default address"
            value="" onChange={props.onMakeAsDefaultChange}
          />
          <label>Make as default address</label>
        </div>
      }
      <br />
      <GlobalStyle.MainBtnStyle onClick={props.onSaveClick} className={!props.data.saveAddressActive ? "disabled" : ""}>
        Save changes
      </GlobalStyle.MainBtnStyle>
    </Styled.AddressFormStyle>
  );
};

export default AddressForm;
